/* ─────────────────────────────────────────────────────────────────────────────
   globalColors.js  –  Single source of truth for all design tokens
   ───────────────────────────────────────────────────────────────────────────── */

/* ── Primary – unified theme color ── */
export const PRIMARY        = '#ea4c89'
export const PRIMARY_HOVER  = '#ec5e95'
export const PRIMARY_LIGHT  = '#f4f2fd'
export const PRIMARY_LIGHT2 = '#fce7f3'
export const PRIMARY_BORDER = 'rgba(234, 76, 137, 0.2)'

/* ── Brand primary (same as PRIMARY — unified) ── */
export const BRAND_PRIMARY       = PRIMARY
export const BRAND_PRIMARY_HOVER = PRIMARY_HOVER

/* ── Text ── */
export const TEXT   = '#111827'
export const TSUB   = '#374151'
export const TMUTED = '#6b7280'
export const TFAINT = '#9ca3af'

/* ── Backgrounds ── */
export const WHITE  = '#ffffff'
export const BGPAGE = '#f9fafb'
export const BGFAINT= '#fafafa'

/* ── Borders ── */
export const BORDER = '#e5e7eb'
export const BLIGHT = '#f0f0f0'
export const BFAINT = '#f3f4f6'

/* ── Status ── */
export const SUCCESS        = '#16a34a'
export const SUCCESS_BG     = '#f0fdf4'
export const SUCCESS_BORDER = '#bbf7d0'
export const WARNING        = '#ca8a04'
export const WARNING_BG     = '#fefce8'
export const WARNING_BORDER = '#fde68a'
export const ORANGE         = '#f97316'
export const ORANGE_BG      = '#fff7ed'
export const ORANGE_BORDER  = '#fed7aa'
export const DANGER         = '#ef4444'
export const DANGER_BG      = '#fef2f2'
export const DANGER_BORDER  = '#fecaca'
export const PURPLE         = '#7c3aed'
export const PURPLE_BG      = '#f5f3ff'
export const PURPLE_BORDER  = '#ddd6fe'
export const GOLD           = '#eab308'
export const GOLD_BG        = '#fefce8'
export const ONLINE_GREEN   = '#22c55e'

/* ── Typography scale (px) ── */
export const font = {
  xs: 11, sm: 12, base: 13, md: 14, lg: 15, xl: 16, xxl: 20, h3: 22, h2: 26, h1: 32,
}

/* ── Border radius (px) ── */
export const radius = {
  xs: 6, sm: 8, md: 12, lg: 16, xl: 20, full: 999,
}

/* ── Shadows ── */
export const shadow = {
  card:      '0 1px 4px rgba(15,23,42,0.04)',
  cardHover: '0 8px 28px rgba(15,23,42,0.09)',
  modal:     '0 32px 80px rgba(15,23,42,0.18)',
  fab:       '0 2px 8px rgba(15,23,42,0.08)',
}

/* ── Convenience object – mirrors old theme.colors shape ── */
export const colors = {
  primary:       PRIMARY,
  primaryHover:  PRIMARY_HOVER,
  primaryLight:  PRIMARY_LIGHT,
  primaryBorder: PRIMARY_BORDER,
  text:          TEXT,
  textSub:       TSUB,
  textMuted:     TMUTED,
  textFaint:     TFAINT,
  textSecondary: TSUB,
  white:         WHITE,
  surface:       WHITE,
  background:    BGPAGE,
  bgPage:        BGPAGE,
  bgFaint:       BGFAINT,
  border:        BORDER,
  borderLight:   BLIGHT,
  borderFaint:   BFAINT,
  success:       SUCCESS,
  successBg:     SUCCESS_BG,
  successBorder: SUCCESS_BORDER,
  warning:       WARNING,
  warningBg:     WARNING_BG,
  warningBorder: WARNING_BORDER,
  orange:        ORANGE,
  orangeBg:      ORANGE_BG,
  orangeBorder:  ORANGE_BORDER,
  danger:        DANGER,
  dangerBg:      DANGER_BG,
  dangerBorder:  DANGER_BORDER,
  purple:        PURPLE,
  purpleBg:      PURPLE_BG,
  purpleBorder:  PURPLE_BORDER,
  gold:          GOLD,
  goldBg:        GOLD_BG,
}
